import Utils from '@/utils/Utils';

export function getGlobalSchema(soData, resourceData) {
  const { searchResult } = soData || {};
  const { projectConfigVO } = resourceData || {};

  const numberOfItems = `${searchResult?.totalCount || 0}`;
  const name = `${searchResult?.globalSearchKeyword}搜索结果`;
  let itemListElement = [];
  if (searchResult?.productRecordList?.length > 0) {
    const list = searchResult.productRecordList.slice(0, 3);
    itemListElement = list.map((item, index) => {
      // 详情页
      const url = `${projectConfigVO?.lcscItemUrl}/${item?.isMro ? 'mro/' : ''}${item?.productVO?.productId}.html`;
      // 单价
      const price = item?.productVO?.productPriceList?.[0]?.thePrice || '';
      // 是否有货
      const availability =
        item?.productVO?.hasStockNow === 'yes' ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock';

      return {
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          name: item?.isMro ? item?.productVO?.productName : item?.productVO?.productModel,
          image: item?.productVO?.breviaryImageUrl,
          description: item?.remarkPrefixTitle,
          brand: {
            '@type': 'Brand',
            name: item?.productVO?.productGradePlateName,
          },
          offers: {
            '@type': 'Offer',
            url,
            priceCurrency: 'CNY',
            price,
            availability,
          },
        },
      };
    });
  }

  const JsonLd = {
    '@context': 'http://schema.org',
    '@type': 'ItemList',
    itemListElement,
    numberOfItems,
    name,
  };

  const MicroData = (
    <div itemScope itemType="https://schema.org/ItemList">
      <meta itemProp="name" content={name}></meta>
      <meta itemProp="numberOfItems" content={numberOfItems}></meta>
      {itemListElement?.map((el, index) => (
        <div itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem" key={index}>
          <meta itemProp="position" content={el?.position} />
          <div itemProp="item" itemScope itemType="https://schema.org/Product">
            <meta itemProp="name" content={el?.item?.name}></meta>
            <meta itemProp="image" content={el?.item?.image}></meta>
            <meta itemProp="description" content={el?.item?.description}></meta>
            <div itemProp="brand" itemScope itemType="https://schema.org/Brand">
              <meta itemProp="name" content={el?.item?.brand?.name}></meta>
            </div>
            <div itemProp="offers" itemScope itemType="https://schema.org/Brand">
              <meta itemProp="url" content={el?.item?.offers?.url}></meta>
              <meta itemProp="priceCurrency" content={el?.item?.offers?.priceCurrency}></meta>
              <meta itemProp="price" content={el?.item?.offers?.price}></meta>
              <meta itemProp="availability" content={el?.item?.offers?.availability}></meta>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return {
    JsonLd,
    MicroData,
  };
}
